import { type GroupByField } from '~entities/summary';

import { MoneyPh } from '~shared/ui/money-ph';

import { createColumnHelper } from '@tanstack/react-table';

import type { SummaryTableData } from '../model/summary-table-data';

const columnHelper = createColumnHelper<SummaryTableData>();

export const getColumns = (groupBy: GroupByField) => [
  columnHelper.accessor((row) => row.merchantName, {
    id: 'merchantName',
    cell: (data) => data.getValue(),
    header: () => <span>Merchant</span>,
  }),
  ...(groupBy === 'by-merchant'
    ? []
    : [
        columnHelper.accessor((row) => row.posName, {
          id: 'posName',
          cell: (data) => data.getValue(),
          header: () => <span>Store</span>,
        }),
      ]),
  columnHelper.accessor((row) => row.loansCount, {
    id: 'loansCount',
    cell: (data) => <div className="flex justify-end">{data.getValue()}</div>,
    header: () => <div className="flex justify-end">Number of loans</div>,
  }),
  columnHelper.accessor((row) => row.loansAmount, {
    id: 'loansAmount',
    cell: (data) => (
      <div className="flex justify-end">
        <MoneyPh value={data.getValue()} />
      </div>
    ),
    header: () => <div className="flex flex-1 justify-end">Loans amount</div>,
  }),
  columnHelper.accessor((row) => row.salesAmount, {
    id: 'salesAmount',
    cell: (data) => (
      <div className="flex justify-end">
        <MoneyPh value={data.getValue()} />
      </div>
    ),
    header: () => <div className="flex flex-1 justify-end">Sales amount</div>,
  }),
];

export enum ColumnId {
  MERCHANT_NAME = 'merchantName',
  POS_NAME = 'posName',
  LOANS_AMOUNT = 'loansAmount',
  SALES_AMOUNT = 'salesAmount',
  LOANS_COUNT = 'loansCount',
}
